/**
 * Call Firebase cloud function to authenticate user using password
 * or Google OAuth2
 * @param token   idToken from Firebase auth
 * @param body    {{electionId}} when logging in with an ID and password
 * @returns {Promise<unknown>} See Firebase function doc header for details
 *                             about return object
 * @private
 */
const getCandidates = async (token, body) => {
  const rootUrl = document.location.hostname === ('localhost') ?
    'http://localhost:5001/onlineballot/us-central1' :
    'https://us-central1-onlineballot.cloudfunctions.net';
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  let parms = {...body, token}
  return new Promise((resolve, reject) => {
    fetch(rootUrl + '/getVoterCandidates', {
      method: 'POST',
      body: parms ? JSON.stringify(parms) : '{}',
      headers,
      // mode: 'cors'
    })
      .then(res => {
        return res.json()
      })
      .then(jsonData => {
        resolve(jsonData);
      })
      .catch(err => {
        reject(err);
      })
  });
}

export default getCandidates;
